// extracted by mini-css-extract-plugin
module.exports = {"up":"chevron_up__xd5RM","down":"chevron_down__6HqCT","left":"chevron_left__IIFZD","right":"chevron_right__xMLMs"};